import { FALLBACK_LOCALE } from '@/lib/format/currency';

// Copy is English, so counts group and agree the way English does, whatever
// the viewer's browser locale.
const COUNT_FORMAT = new Intl.NumberFormat(FALLBACK_LOCALE, { maximumFractionDigits: 0 });
const PLURAL_RULES = new Intl.PluralRules(FALLBACK_LOCALE);

/** Whole units (documents, pages, runs) never render a fraction. */
export function formatCount(value: number): string {
  return COUNT_FORMAT.format(value);
}

/**
 * The noun that agrees with a count: `document` for 1, `documents` for 0 or 2.
 * Pass the plural for a noun that does not take an `s`.
 */
export function pluralNoun(count: number, singular: string, plural = `${singular}s`): string {
  return PLURAL_RULES.select(count) === 'one' ? singular : plural;
}
